<template>
  <div class="w-full">
    <vs-divider v-if="alertBanner.length > 0" class="hidden md:block mt-0" />
    <div v-if="alertBanner.length > 0" class="alert-banner__track">
      <div class="alert-banner__desktop">
      <carousel
        :perPage="1"
        :paginationEnabled="false"
        :loop="true"
        :navigateTo="navigateTo"
      >
        <slide v-for="(slide, key) in alertBanner" :key="key">
          <div class="alert-banner__row hidden md:flex items-center justify-between pl-2 md:px-5">
            <vs-icon
              icon="arrow_back_ios"
              size="small"
              class="mr-4 cursor-pointer"
              @click="handleBack(key)"
            ></vs-icon>

            <span
              @click="handleSelectBanner(slide)"
              class="mx-2 w-full text-center cursor-pointer hover:underline text-sm md:text-base text-black font-medium"
              >{{ slide.title }}</span
            >

            <vs-icon
              icon="arrow_forward_ios"
              size="small"
              class="cursor-pointer"
              @click="handleNext(key)"
            ></vs-icon>
          </div>
        </slide>
      </carousel>
      </div>

      <div
        class="alert-banner__cards"
        :class="{ 'alert-banner__cards--single': alertBanner.length === 1 }"
        ref="cardScroller"
        @scroll="onCardScroll"
      >
        <button
          v-for="(slide, key) in alertBanner"
          :key="'card-' + key"
          type="button"
          class="alert-banner__card"
          @click="handleSelectBanner(slide)"
        >
          <span class="alert-banner__card-title">{{ slide.title }}</span>
          <vs-icon icon="arrow_forward_ios" size="15px"></vs-icon>
        </button>
      </div>
      <div class="alert-banner__dots" v-if="alertBanner.length > 1">
        <button
          v-for="(slide, key) in alertBanner"
          :key="'dot-' + key"
          type="button"
          :class="{ 'is-active': activeCard === key }"
          :aria-label="'Alert ' + (key + 1)"
          @click="scrollToCard(key)"
        ></button>
      </div>
      <vs-popup
        class="learnMorePopup"
        :title="selectedBanner.title"
        :fullscreen="isMobileView ? true : false"
        :active.sync="learnMorePopupActive"
        :button-close-hidden="true"
      >
        <div class="p-5">
          <div
            class="text-center hidden md:block"
            v-if="selectedBanner.images && selectedBanner.images.desktop"
          >
            <img
              width="50%"
              :src="
                (selectedBanner.images && selectedBanner.images.desktop) || ''
              "
              alt="image"
            />
          </div>
          <div
            class="text-center block md:hidden"
            v-if="selectedBanner.images && selectedBanner.images.mobile"
          >
            <img
              width="50%"
              :src="
                (selectedBanner.images && selectedBanner.images.mobile) || ''
              "
              alt="image"
            />
          </div>
          <div class="text-center text-3xl my-8">
            {{ selectedBanner.title }}
          </div>
          <div
            class="alert-description"
            v-html="selectedBanner.description"
            style="font-size: 14px; margin-top: 4px"
          ></div>
          <div class="text-center mt-4 mb-8">
            <vs-button
              color="primary"
              @click="learnMorePopupActive = false"
              >I Understand</vs-button
            >
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

export default {
  props: {
    page: {
      type: String,
      default: '',
    },
    slug: {
      type: String,
      default: '',
    },
  },
  components: {
    Carousel,
    Slide,
  },
  data: () => ({
    alertId: '',
    selectedBanner: {},
    alertBanner: [],
    learnMorePopupActive: false,
    isMobileView: null,
    navigateTo: 0,
    activeCard: 0,
  }),
  methods: {
    ...mapActions('storeAlertNotification', [
      'fetchStoreAlertsBanner',
      'fetchStoreAlertsBannerByCategoryId',
      'fetchStoreAlertsBannerByBrand',
      'fetchStoreAlertsBannerByProductId',
      'fetchCheckoutStoreAlertsBanner',
    ]),
    onCardScroll(event) {
      const el = event.target;
      const card = el.querySelector('.alert-banner__card');
      if (!card) return;
      if (this._cardStepWidth == null || this._cardStepCount !== this.alertBanner.length) {
        const styles = window.getComputedStyle(el);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        this._cardStepWidth = card.offsetWidth + gap;
        this._cardStepCount = this.alertBanner.length;
      }
      const index = Math.round(el.scrollLeft / this._cardStepWidth);
      this.activeCard = Math.max(0, Math.min(index, this.alertBanner.length - 1));
    },
    scrollToCard(index) {
      const el = this.$refs.cardScroller;
      if (!el) return;
      const card = el.querySelectorAll('.alert-banner__card')[index];
      if (!card) return;
      el.scrollTo({ left: Math.max(0, card.offsetLeft - 16), behavior: 'smooth' });
      this.activeCard = index;
    },
    async fetchAndSortAlerts(fetchMethod, payload = null) {
      try {
        const res = payload ? await fetchMethod(payload) : await fetchMethod();
        const sortedAlerts = this.sortedData(res.data.data);

        return sortedAlerts.map((alert) => {
          if (alert.alert_type === 'success') alert.alert_type = 'primary';
          if (alert.alert_type === 'error') alert.alert_type = 'danger';
          return alert;
        });
      } catch (error) {
        console.error(error.message);
        return [];
      }
    },
    updateHomepage(showAlert) {
      var element = document.getElementsByClassName('router-content');
      if (showAlert) {
        element[0].classList.add('shop-alert-margin');
        element[0].classList.remove('shop-margin');
      } else {
        element[0].classList.add('shop-margin');
        element[0].classList.remove('shop-alert-margin');
      }
    },
    sortedData(alerts) {
      return [...alerts].sort((a, b) => {
        if (a.priorityLevel == null && b.priorityLevel == null) {
          return 0;
        }
        if (a.priorityLevel == null) {
          return 1;
        }
        if (b.priorityLevel == null) {
          return -1;
        }
        return a.priorityLevel - b.priorityLevel;
      });
    },
    async getBanners() {
      try {
        const items = JSON.parse(
          JSON.stringify(
            this.$store.state.eCommerce.cartItems.slice().reverse()
          )
        );
        const productId = [...items].map((item) => item.productStoreId);

        const res = await this.fetchCheckoutStoreAlertsBanner({
          productId: productId,
        });

        const tempData = this.sortedData(res.data.data);
        tempData.map((alert) => {
          if (alert.alert_type === 'success') alert.alert_type = 'primary';
          if (alert.alert_type === 'error') alert.alert_type = 'danger';
          return alert;
        });
        this.alertBanner = tempData;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAlertByProduct() {
      this.alertBanner = await this.fetchAndSortAlerts(
        this.fetchStoreAlertsBannerByProductId,
        this.$route.params.id
      );
    },
    async fetchAlertByBrand() {
      this.alertBanner = await this.fetchAndSortAlerts(
        this.fetchStoreAlertsBannerByBrand,
        this.slug
      );
    },
    async fetchAlertByCategory() {
      this.alertBanner = await this.fetchAndSortAlerts(
        this.fetchStoreAlertsBannerByCategoryId,
        this.slug
      );
    },
    async fetchAlertDetails() {
      this.alertBanner = await this.fetchAndSortAlerts(
        this.fetchStoreAlertsBanner,
        {
          type: 'homepage',
        }
      );
    },
    handleSelectBanner(details) {
      this.selectedBanner = { ...details };
      this.learnMorePopupActive = true;
    },
    myEventHandler() {
      this.isMobileView = window.innerWidth < 768;
    },
    handleBack(index) {
      if (index !== 0) this.navigateTo = this.navigateTo - 1;
    },
    handleNext(index) {
      if (index !== this.alertBanner.length - 1)
        this.navigateTo = this.navigateTo + 1;
      if (index === this.alertBanner.length - 1) this.navigateTo = 0;
    },
    fetchAlertBanners() {
      const fetchMap = {
        homepage: this.fetchAlertDetails,
        promotions: this.fetchAlertDetails,
        'fresh-life': this.fetchAlertDetails,
        category: this.fetchAlertByCategory,
        brand: this.fetchAlertByBrand,
        productDetail: this.fetchAlertByProduct,
      };

      const fetchMethod = fetchMap[this.page];
      return fetchMethod ? fetchMethod() : undefined;
    },
  },
  computed: {
    toggleScreenSize: function () {
      if (this.isMobileView) {
        return !this.learnMorePopupActive;
      }
      return true;
    },
  },
  watch: {
    page: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.alertBanner = [];
          if (newVal === 'checkout') {
            return this.getBanners();
          }
          return this.fetchAlertBanners();
        }
      },
      immediate: true,
    },
    slug: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.alertBanner = [];
          this.fetchAlertBanners();
        }
      },
      immediate: true,
    },
    alertBanner: {
      handler(value) {
        this.updateHomepage(value.length > 0);
        this.$store.commit(
          'eCommerce/UPDATE_SHOW_ALERT_HEADER',
          value.length > 0
        );
      },
    },
    '$store.state.eCommerce.cartItems': {
      handler() {
        if (this.page === 'checkout') {
          return this.getBanners();
        }
      },
    },
  },
  created() {
    this.fetchAlertBanners();
  },
  mounted() {
    window.addEventListener('resize', this.myEventHandler);
    this.myEventHandler();
    this.updateHomepage(this.alertBanner.length > 0);
    this.$store.commit(
      'eCommerce/UPDATE_SHOW_ALERT_HEADER',
      this.alertBanner.length > 0
    );
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventHandler);
  },
};
</script>

<style lang="scss">
.alert-banner__track {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  min-height: 0;
  margin: 0;
}

.alert-banner__desktop {
  display: none;
}

.alert-banner__cards {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  scroll-snap-type: x mandatory;
  scroll-padding-left: 16px;
  padding: 8px 16px 0 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.alert-banner__cards::-webkit-scrollbar {
  display: none;
}

.alert-banner__cards--single {
  padding-bottom: 8px;

  .alert-banner__card {
    flex-basis: 100%;
    width: 100%;
    max-width: 100%;
  }
}

.alert-banner__card {
  flex: 0 0 84%;
  width: 84%;
  max-width: 84%;
  min-width: 0;
  scroll-snap-align: start;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 0;
  padding: 8px 12px;
  background: #ffffff;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(10, 31, 21, 0.06), 0 6px 16px rgba(10, 31, 21, 0.06);
  text-align: left;
  cursor: pointer;
  touch-action: pan-x;
}

.alert-banner__card-title {
  flex: 1;
  color: #0a1f15;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
}

.alert-banner__card .vs-icon {
  flex-shrink: 0;
  color: #5c675f;
}

.alert-banner__dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 6px 0 8px;
}

.alert-banner__dots button {
  width: 6px;
  height: 6px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: #d9dbd6;
}

.alert-banner__dots button.is-active {
  width: 18px;
  background: #0e4333;
}

@media (min-width: 768px) {
  .alert-banner__desktop {
    display: block;
  }

  .alert-banner__cards,
  .alert-banner__dots {
    display: none;
  }
}

.alert-banner__track .VueCarousel,
.alert-banner__track .VueCarousel-wrapper,
.alert-banner__track .VueCarousel-inner {
  width: 100%;
}

.alert-banner__track .VueCarousel-inner {
  align-items: center;
}

.alert-banner__track .VueCarousel-slide {
  display: flex;
  align-items: center;
}

.alert-banner__row {
  width: 100%;
  min-height: 40px;
  align-items: center;
}

.alert-banner__row .vs-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  line-height: 1;
}

.learnMorePopup .vs-popup {
  width: 50%;
  overflow-wrap: break-word;
}

.con-vs-popup.fullscreen .vs-popup {
  max-width: 100%;
  max-height: 100%;
  margin: 0;
}
.shop-margin,
.shop-alert-margin {
  margin-top: 0 !important;
}

.alert-description {
  ul,
  ol {
    padding-left: 2.5rem;
  }
  ul {
    list-style-type: initial;
  }
  ol {
    list-style-type: auto;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  pre,
  address {
    display: block;
    margin-inline-start: 0;
    margin-inline-end: 0;
    unicode-bidi: isolate;
  }
  p {
    margin-block: 1em;
  }
  h1 {
    font-size: 2em;
    margin-block: 0.67em;
    font-weight: bold;
  }
  h2 {
    font-size: 1.5em;
    margin-block: 0.83em;
  }
  h3 {
    font-size: 1.17em;
    margin-block: 1em;
  }
  h4 {
    margin-block: 1.33em;
  }
  h5 {
    font-size: 0.83em;
    margin-block: 1.67em;
  }
  h6 {
    font-size: 0.67em;
    margin-block: 2.33em;
  }
  pre {
    font-family: monospace;
    white-space: pre;
    margin: 1em 0;
  }
  address {
    font-style: italic;
  }
}
</style>
